import { ErrorBoundary } from "react-error-boundary";
import { Route, Routes } from "react-router";
import { AppFullFallbackComponent } from "./components/lib";
import AuthLayout from "./layouts/AuthLayout";
import StatsLayout from "./layouts/StatsLayout";
import AuthEmailConfirm from "./routes/auth/components/AuthEmailConfirm";
import AuthRegisterDemo from "./routes/auth/components/AuthRegisterDemo";
import AuthResendEmailConfirm from "./routes/auth/components/AuthResendEmailConfirm";
import AuthResetPassword from "./routes/auth/components/AuthResetPassword";
import AuthResetPasswordConfirm from "./routes/auth/components/AuthResetPasswordConfirm";
import AuthSignIn from "./routes/auth/components/AuthSignIn";
import StatsDashboard from "./routes/stats/components/StatsDashboard";
import StatsWelcome from "./routes/stats/components/StatsWelcome";

const AppUnauthenticated = () => {
  return (
    <div>
      <main>
        <ErrorBoundary
          fallbackRender={({ error }) => (
            <AppFullFallbackComponent error={error} />
          )}
        >
          <AppRoutes />
        </ErrorBoundary>
      </main>
    </div>
  );
};

const AppStatsRoutes = () => {
  return (
    <StatsLayout>
      <Routes>
        <Route path="dashboard" element={<StatsDashboard />} />
        <Route path="*" element={<StatsWelcome />} />
      </Routes>
    </StatsLayout>
  );
};

const AppAuthRoutes = () => {
  return (
    <AuthLayout>
      <Routes>
        <Route path="reset-password" element={<AuthResetPassword />} />
        <Route path="reset-password" element={<AuthResetPassword />} />
        <Route
          path="reset-password-confirmation"
          element={<AuthResetPasswordConfirm />}
        />
        <Route path="email-confirmation" element={<AuthEmailConfirm />} />
        <Route
          path="resend-email-confirmation"
          element={<AuthResendEmailConfirm />}
        />
        <Route path="register" element={<AuthRegisterDemo />} />
        <Route path="register/:registryId" element={<AuthRegisterDemo />} />
        <Route path="*" element={<AuthSignIn />} />
      </Routes>
    </AuthLayout>
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/stats/*" element={<AppStatsRoutes />} />
      <Route path="/auth/*" element={<AppAuthRoutes />} />
      <Route path="*" element={<AppAuthRoutes />} />
    </Routes>
  );
};

export default AppUnauthenticated;
